import { useState, useEffect } from 'react';
import './HorizontalTabs.css';
import { useTheme } from '../../theme/ThemeContext';

export default function HorizontalTabs({ items, onSelect, initialSelectedItem }) {
    const { theme } = useTheme();
    // const [selectedItem, setSelectedItem] = useState(items[0]);
    const [selectedItem, setSelectedItem] = useState(initialSelectedItem);


    function handleClick(item) {
        setSelectedItem(item);
        if (onSelect) {
            onSelect(item);
        }
    }

    return (
        <div className="horizontalTabs">
            {items.map((item, index) => (
                <div
                    key={index}
                    className={`tabItem ${selectedItem === item ? 'active' : ''}`}
                    onClick={() => handleClick(item)}
                >
                    {item}
                </div>
            ))}
        </div>
    );
}
